'use strict';

module.exports = thematicBreak;

/* Transform a thematic break / horizontal rule. */
function thematicBreak(h, node) {
  return h(node, 'hr');
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
// module id = 397
// module chunks = 0